import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Home from "./components/Home";
import ParkDetail from "./components/Parks/ParkDetail";

interface Image {
  url: string;
  processedUrl: { small: string };
}

export interface ParkQueryProps {
  name?: String;
  fullName?: String;
  directionsInfo?: string;
  states?: string;
  images?: [Image];
}

function App() {
  return (
    <React.Fragment>
      <Router>
        <Switch>
          <Route exact path="/">
            <Home />
          </Route>
          <Route path="/park/:parkCode">
            <ParkDetail />
          </Route>
        </Switch>
      </Router>
    </React.Fragment>
  );
}

export default App;
